import { useEffect, useRef } from 'react';

import { useCoworkingOfferTypeSelector } from '../../../../../../../../hooks/selectors/useCoworkingOfferTypeSelector';
/**
 * @todo Удалить строку с RS
 * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
 */
import { useCoworkingWorkplacePriceEnabledRS } from '../../../../../../../../hooks/useCoworkingWorkplacePriceEnabledRS';
import { ECoworkingOfferType, EJsonQueryPriceType } from '../../../../../../../../repositories/common/json_query';

export function useCoworkingOfferTypeChangeEffect(
  priceType: EJsonQueryPriceType,
  onPriceTypeChange: (priceType: EJsonQueryPriceType) => void,
) {
  const isFirstRender = useRef<boolean>(true);

  const coworkingOfferType = useCoworkingOfferTypeSelector();

  /**
   * @start
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
   */
  const coworkingWorkplacePriceEnabledRS = useCoworkingWorkplacePriceEnabledRS();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (
      /**
       * @start
       * @todo Удалить строку с RS
       * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
       */
      coworkingWorkplacePriceEnabledRS &&
      coworkingOfferType
    ) {
      const newPriceType = coworkingOfferType.includes(ECoworkingOfferType.Office)
        ? EJsonQueryPriceType.All
        : EJsonQueryPriceType.Workplace;

      if (newPriceType !== priceType) {
        onPriceTypeChange(newPriceType);
      }
    }
  }, [coworkingOfferType]);
}
